export default class ApiClient {
  constructor(client = {}) {
    this.id = client.id || null
    this.name = client.name || null
    this.secret = client.secret || null
  }
}